import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { SearchTagMap } from '../../models/models';

@Component({
    selector: 'tagmap-list',
    templateUrl: './tagmap-list.component.html',
    standalone: false
})
export class TagMapList implements OnChanges, OnInit {
    @Input() recordID: number = 0;
    @Input() recordTypeName: string = "";
    @Input() isPrefix: boolean = true;
    @Input() isForOrder: boolean = false;
    @Input() refreshDate: Date = new Date();

    public isLoading: boolean = false;
    //public prefix: string = "";
    public tagMouseOverID: number = 0;

    //public selectedCarrierReps: Employee[] = [];
    public tagMapList: SearchTagMap[] = [];

    constructor(private orderService: OrderService) {
    }

    ngOnInit() {
        //this.getTags();
        //console.log("ngOnInit", this.recordID, this.recordTypeName, this.tagMapList, this.refreshDate);
    }

    ngOnChanges() {
        this.getTags();
        //console.log("ngOnChanges", this.recordID, this.recordTypeName, this.tagMapList, this.refreshDate);
    }

    private getTags() {
        this.tagMapList.length = 0;
        if (this.isForOrder) {
            this.getTagMapForOrderByQuoteOrderID();
        }
        else if (this.recordTypeName == "QuoteOrder") {
            //this.prefix = "O";
            this.getTagMapByQuoteOrderID();
        }
        else if (this.recordTypeName == "QuoteOrderLine") {
            //this.prefix = "L";
            this.getTagMapByQuoteOrderLineID();
        }
        else if (this.recordTypeName == "Customer") {
            //this.prefix = "C";
            this.getTagMapByCustomerID();
        }
    }

    private getTagMapForOrderByQuoteOrderID() {
        this.orderService.getSearchTagMapForOrderByQuoteOrderID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private getTagMapByQuoteOrderID() {
        this.orderService.getSearchTagMapForOrderByQuoteOrderID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private getTagMapByQuoteOrderLineID() {
        this.orderService.getSearchTagMapByQuoteOrderLineID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private getTagMapByCustomerID() {
        this.orderService.getSearchTagMapByCustomerID(this.recordID).subscribe(result => {
            this.tagMapList = result.resultCollection;
            this.setupTagMapList();
        });
    }

    private setupTagMapList() {
        var allTags: SearchTagMap[] = Object.assign([], this.tagMapList);
        var orderTags = allTags.filter(t => t.recordTypeName == "QuoteOrder");
        var loadTags = allTags.filter(t => t.recordTypeName == "QuoteOrderLine");
        var customerTags = allTags.filter(t => t.recordTypeName == "Customer");
        orderTags = orderTags.sort((left, right): number => {
            if (left.tagTypeName < right.tagTypeName) return -1;
            if (left.tagTypeName > right.tagTypeName) return 1;
            return 0;
        });
        loadTags = loadTags.sort((left, right): number => {
            if (left.tagTypeName < right.tagTypeName) return -1;
            if (left.tagTypeName > right.tagTypeName) return 1;
            return 0;
        });
        customerTags = customerTags.sort((left, right): number => {
            if (left.tagTypeName < right.tagTypeName) return -1;
            if (left.tagTypeName > right.tagTypeName) return 1;
            return 0;
        });
        this.tagMapList.length = 0;
        this.tagMapList.push(...orderTags);
        this.tagMapList.push(...loadTags);
        this.tagMapList.push(...customerTags);
        //console.log("setupTagMapList", orderTags, loadTags, customerTags, this.tagMapList);
    }
}
